(function () {
    'use strict';

    angular
        .module('app.completions')
        .factory('completions', completions);

    completions.$inject = ['completions.dialog', 'completionsService'];

    /* @ngInject */
    function completions(dialog, completionsService) {
        var service = {
            complete: complete,
            completionClass: completionClass,
            completionInitials: completionInitials,
            completeCallback: null,
            completionShowing: null,
            hasCompletionType: completionsService.hasCompletionType,
            isAllDone: completionsService.isAllDone,
            isNothingCompleted: completionsService.isNothingCompleted,
            showCompletionDot: showCompletionDot
        };

        return service;

        function complete(i, $event) {
            $event.preventDefault();
            $event.stopPropagation();
            if (service.completionShowing) {
                service.completionShowing();
            }
            var title = i.BookingId > 0 ? i.EventName : i.TaskDescription;

            return dialog.display(i).then(function () {
                if (service.completeCallback) {
                    service.completeCallback();
                }
            }, function () { });
        }

        function showCompletionDot(item, completionTypes) {
            
            return completionsService.isAllDone(item) || completionsService.isNothingCompleted(item, completionTypes)
        }

        function completionClass(item) {
            var completion = item.Completions[0];

            if (completion) {
                if (completion.CompletedAtUtc) {
                    if (completion.Color) {
                        return { "background-color": completion.Color }
                    }
                    else {
                        return { "background-color": "#076d10" }
                    }
                }
            }
            return { "background-color": "red" };
        }

        function completionInitials(item) {
            var completion = item.Completions[0];
            if (completion) {
                if (completion.CompletedAtUtc) {
                    return completion.Initials;
                }
            }
        }
    }
}());
